import React, { useEffect, useRef, useState } from "react";
import { useParams, Link, useLocation } from "react-router-dom";
import { Helmet, HelmetProvider } from 'react-helmet-async';
// import "../../index.css";
import ImageCarousel from "./ImageCarousel";



const NewsletterDetail = ({ newsletterData, currentLanguage }) => {
  const { newsletterId } = useParams();
  const [expandedItems, setExpandedItems] = useState({});
  const [showReadMoreItems, setShowReadMoreItems] = useState({});
  const [showMoreUpcoming, setShowMoreUpcoming] = useState(false);
  const descriptionRefs = useRef({});

  const newsletter = newsletterData.find(
    (e) => e.path.split("/").pop() === newsletterId
  ); // ✅ Moved before any use of 'newsletter'
  // left.image = [
  //   {
  //     id,
  //     name,
  //     mediaImage5: [
  //       { url, alt, title }
  //     ]
  //   }
  // ]

  useEffect(() => {
    const visibility = {};
    newsletter?.sectionOneTemplate?.forEach((item) => {
      const leftRef = descriptionRefs.current[`left-${item.id}`]; // FIX: use left- key
      const rightRef = descriptionRefs.current[`right-${item.id}`]; // keep right as is

      if (leftRef) {
        visibility[`left-${item.id}`] = leftRef.scrollHeight > 250; // also FIX the key here
      }

      if (rightRef) {
        visibility[`right-${item.id}`] = rightRef.scrollHeight > 170;
      }
    });


    // Section Two
    newsletter?.sectionTwoTemplate?.forEach((item) => {
      const key = `sectionTwo-${item.id}`;
      const ref = descriptionRefs.current[key];
      if (ref) visibility[key] = ref.scrollHeight > 300;
    });

    // Section Three
    newsletter?.sectionThreeTemplate?.forEach((section) => {
      const partOneKey = `sectionThree-partOne-${section.id}`;
      const partTwoKey = `sectionThree-partTwo-${section.id}`;

      const refOne = descriptionRefs.current[partOneKey];
      const refTwo = descriptionRefs.current[partTwoKey];

      if (refOne) visibility[partOneKey] = refOne.scrollHeight > 200;
      if (refTwo) visibility[partTwoKey] = refTwo.scrollHeight > 200;
    });


    setShowReadMoreItems(visibility);
  }, [newsletter?.sectionOneTemplate]);


  const location = useLocation();


  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const toggleReadMore = (id) => {
    setExpandedItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };
  if (!newsletter) {
    return <div className="text-center text-gray-600">Newsletter not found</div>;
  }

  const teamCorner = newsletter?.teamCornerSection || null;

  return (
    <section className="relative z-0 pb-10 pt-20">
      <div className="container mx-auto px-4 md:px-8 lg:px-12 xl:px-20 max-w-screen-xl">
        {/* Back to list link */}
        <Link
          to={`/${currentLanguage === 'hi' ? 'hi/' : ''}newsletter`}
          className="text-indian-red font-body hover:underline mb-2"
        >
          &larr; Back to Newsletter List
        </Link>
        <Helmet>
          <title>{newsletter.title}</title> {/* Set dynamic title here */}
        </Helmet>
        {/* Title */}
        <h1 className="text-4xl sm:text-3xl lg:text-4xl mt-4 font-heading font-bold uppercase relative text-indian-red text-center section-heading">
          {newsletter.title}
          <p className="text-gray-600 text-xl">{newsletter.shortDescription}</p>
          <div className="relative flex items-center justify-center line-with-image">
            <img
              src="/assets/SHIKSHA_Flower_SVG.svg" 
              alt="headingflower"
              className="h-7 sm:h-6 lg:h-9  bg-white p-1 sm:p-2"
            />
          </div>
        </h1>

        {/* Banner Image */}
        {newsletter.bannerImage && (
          <div className="my-5">
            <img
              src={newsletter.bannerImage.url}
              alt={newsletter.bannerImage.alt || "Banner"}
              className="w-full h-[25rem] object-cover rounded-lg shadow-lg"
              loading="lazy"
              decoding="async"
            />
          </div>
        )}

        {/* Program Highlights Table */}
        {newsletter.programHighlightsTableD &&
          Array.isArray(newsletter.programHighlightsTableD) &&
          newsletter.programHighlightsTableD.length > 0 && (
            <div className="mt-10">
              {/* Title */}
              {newsletter.programHighlightsTitle && (
                <h2 className="text-2xl font-bold text-indian-red text-center font-heading mb-4">
                  {newsletter.programHighlightsTitle}
                </h2>
              )}

              <div className="overflow-x-auto">
                <table className="w-full border border-gray-300 rounded-lg">
                  <thead className="bg-warm-orange text-indian-red font-heading font-bold">
                    <tr>
                      {/* <th className="px-4 py-2 text-left">S.No</th> */}
                      <th className="px-4 py-2 text-left">
                        {newsletter.programHighlightsColumn || "Program Column 1"}
                      </th>
                      <th className="px-4 py-2 text-left">
                        {newsletter.programTwoColumn || "Program Column 2"}
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {newsletter.programHighlightsTableD.map((row, index) => (
                      <tr
                        key={row.id || index}
                        className="border-t border-gray-200 font-body hover:bg-gray-50"
                      >
                        {/* <td className="px-4 py-2">{index + 1}</td> */}
                        <td className="px-4 py-2">{row.columnOne}</td>
                        <td className="px-4 py-2">{row.columnTwo}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}


        {/* ✅ Section One Template */}
        {Array.isArray(newsletter.sectionOneTemplate) &&
          newsletter.sectionOneTemplate.length > 0 &&
          newsletter.sectionOneTemplate.map((item, index) => {
            const left = item?.partOne;
            const right = item?.partTwo;

            if (
              !left?.titleAndDescription?.title &&
              !left?.titleAndDescription?.descriptions?.value &&
              !left?.image?.mediaImage5?.url &&
              !right?.titleAndDescription?.title &&
              !right?.titleAndDescription?.descriptions?.value &&
              !right?.image?.mediaImage5?.url
            ) {
              return null;
            }

            return (
              <div
                key={item.id || index}
                className="mt-10 grid grid-cols-1 md:grid-cols-6 gap-6 items-stretch"
              >
                {/* Left */}
                <div className="md:col-span-3 bg-warm-orange p-6 rounded-2xl shadow-md h-full flex flex-col justify-start self-stretch">
                  {/* Title */}
                  {left?.titleAndDescription?.title && (
                    <h2 className="text-xl sm:text-2xl font-semibold text-indian-red font-heading mb-4">
                      {left.titleAndDescription.title}
                    </h2>
                  )}

                  {/* Image */}
                  {Array.isArray(left?.image) && left.image.length > 0 && (
                    <div className="mb-4 w-full
                        h-[200px]        /* xs - mobile */
                        sm:h-[450px]     /* sm - large mobile */
                        md:h-[420px]     /* md - TABLET FIX */
                        lg:h-[350px]     /* lg - desktop */
                        overflow-hidden
                        rounded-xl
                        shadow-sm
                      ">
                      <ImageCarousel images={left.image} />
                    </div>
                  )}


                  {/* Description (with Read More) */}
                  {left?.titleAndDescription?.descriptions?.value && (
                    <div className="relative text-sm leading-relaxed text-white font-body text-justify bg-warm-orange">
                      <div
                        className={`transition-all duration-300 h-[157px] pr-2 ${expandedItems[`left-${item.id}`]
                          ? "overflow-y-auto"
                          : "overflow-hidden"
                          }`}
                      >
                        <div
                          ref={(el) => (descriptionRefs.current[`left-${item.id}`] = el)}
                          dangerouslySetInnerHTML={{
                            __html: left.titleAndDescription.descriptions.value,
                          }}
                          className="pr-2 text-black font-body"
                        />
                      </div>

                      {/* Read More / Read Less */}
                      {showReadMoreItems[`left-${item.id}`] &&
                        !expandedItems[`left-${item.id}`] && (
                          <div className="text-center mt-2">
                            <button
                              onClick={() =>
                                setExpandedItems((prev) => ({
                                  ...prev,
                                  [`left-${item.id}`]: true,
                                }))
                              }
                              className="text-indian-red font-medium underline hover:text-dark-umber font-body transition"
                            >
                              Read More
                            </button>
                          </div>
                        )}

                      {expandedItems[`left-${item.id}`] && (
                        <div className="text-center mt-2">
                          <button
                            onClick={() => {
                              const el = descriptionRefs.current[`left-${item.id}`];
                              if (el) el.parentElement.scrollTop = 0;
                              setExpandedItems((prev) => ({
                                ...prev,
                                [`left-${item.id}`]: false,
                              }));
                            }}
                            className="text-indian-red font-medium underline hover:text-dark-umber font-body transition"
                          >
                            Read Less
                          </button>
                        </div>
                      )}
                    </div>
                  )}

                </div>

                {/* Right */}
                <div className="md:col-span-3 bg-white p-6 font font-heading rounded-2xl shadow-md h-full self-stretch flex flex-col justify-start ">
                  {right?.titleAndDescription?.title && (
                    <h2 className="text-xl sm:text-2xl font-semibold text-indian-red mb-3">
                      {right.titleAndDescription.title}
                    </h2>
                  )}

                  {right?.titleAndDescription?.descriptions?.value && (
                    <div className="relative text-sm text-gray-700 h-full text-justify">
                      <div
                        className={`transition-all duration-300 h-[145px] pr-2 ${expandedItems[`right-${item.id}`]
                          ? "overflow-y-auto"
                          : "overflow-hidden"
                          }`}
                      >
                        <div
                          ref={(el) =>
                            (descriptionRefs.current[`right-${item.id}`] = el)
                          }
                          dangerouslySetInnerHTML={{
                            __html: right.titleAndDescription.descriptions.value,
                          }}
                          className="pr-2 font-body"
                        />
                      </div>

                      {/* Read More / Read Less */}
                      {showReadMoreItems[`right-${item.id}`] &&
                        !expandedItems[`right-${item.id}`] && (
                          <div className=" text-center mt-2">
                            <button
                              onClick={() =>
                                setExpandedItems((prev) => ({
                                  ...prev,
                                  [`right-${item.id}`]: true,
                                }))
                              }
                              className="text-indian-red font-body unberline font-medium underline hover:text-dark-umber transition"
                            >
                              Read More
                            </button>
                          </div>
                        )}

                      {expandedItems[`right-${item.id}`] && (
                        <div className=" text-center mt-2">
                          <button
                            onClick={() => {
                              const el = descriptionRefs.current[`right-${item.id}`];
                              if (el) el.parentElement.scrollTop = 0;
                              setExpandedItems((prev) => ({
                                ...prev,
                                [`right-${item.id}`]: false,
                              }));
                            }}
                            className="text-indian-red font-body font-medium hover:text-dark-umber underline transition"
                          >
                            Read Less
                          </button>
                        </div>
                      )}

                      {/* Image */}
                      {Array.isArray(right?.image) && right.image.length > 0 && (
                        <div className="mt-4 w-full h-[200px] sm:h-[450px] md:h-[420px] lg:h-[350px] overflow-hidden rounded-xl shadow-sm">
                          <ImageCarousel images={right.image} />
                        </div>
                      )}

                    </div>
                  )}
                </div>
              </div>
            );
          })}



        {/* Section Two Template (if exists and has valid content) */}
        {Array.isArray(newsletter.sectionTwoTemplate) &&
          newsletter.sectionTwoTemplate.length > 0 &&
          newsletter.sectionTwoTemplate.map((item, index) => {
            const title = item?.titleAndDescription?.title;
            const desc = item?.titleAndDescription?.descriptions?.value;
            const images = item?.image;
            const imageAlt = item?.image?.mediaImage5?.alt || "Section image";

            // if (!title && !desc && !imageUrl) return null;

            return (
              <div
                key={item.id || index}
                className="mt-10  grid grid-cols-1 md:grid-cols-6 gap-6 items-start "
              >
                {/* Left Side (Text) */}
                <div className="md:col-span-3 bg-indian-red rounded-2xl shadow-md p-4 h-full">
                  {title && (
                    <h2 className="text-xl sm:text-2xl font-semibold text-warm-orange mb-2">
                      {title}
                    </h2>
                  )}
                  {desc && (
                    <div className="relative text-sm text-white text-justify">
                      <div
                        className={`transition-all duration-300 h-[300px] pr-2 ${expandedItems[`sectionTwo-${item.id}`]
                          ? "overflow-y-auto"
                          : "overflow-hidden"
                          }`}
                      >
                        <div
                          ref={(el) =>
                            (descriptionRefs.current[`sectionTwo-${item.id}`] = el)
                          }
                          dangerouslySetInnerHTML={{ __html: desc }}
                          className="pr-2"
                        />
                      </div>

                      {!expandedItems[`sectionTwo-${item.id}`] &&
                        showReadMoreItems[`sectionTwo-${item.id}`] && (
                          <div className="text-center mt-2">
                            <button
                              onClick={() =>
                                setExpandedItems((prev) => ({
                                  ...prev,
                                  [`sectionTwo-${item.id}`]: true,
                                }))
                              }
                              className="text-yellow-300 font-medium underline hover:text-yellow-500 transition"
                            >
                              Read More
                            </button>
                          </div>
                        )}

                      {expandedItems[`sectionTwo-${item.id}`] && (
                        <div className="text-center mt-2">
                          <button
                            onClick={() => {
                              const el =
                                descriptionRefs.current[`sectionTwo-${item.id}`];
                              if (el) el.parentElement.scrollTop = 0;
                              setExpandedItems((prev) => ({
                                ...prev,
                                [`sectionTwo-${item.id}`]: false,
                              }));
                            }}
                            className="text-yellow-300 font-medium underline hover:text-yellow-500 transition"
                          >
                            Read Less
                          </button>
                        </div>
                      )}
                    </div>
                  )}
                </div>

                {/* Right Side (Image) */}
                {/* Right Side (Image Carousel) */}
                <div className="md:col-span-3 bg-white rounded-2xl shadow-md p-6 w-full h-[270px] sm:h-[470px] md:h-[430px] lg:h-[430px] overflow-hidden">
                  {Array.isArray(images) && images.length > 0 && (
                    <ImageCarousel images={images} />
                  )}
                </div>

              </div>

            );
          })}

        {/* Section three Template (if exists) */}

        {Array.isArray(newsletter.sectionThreeTemplate) &&
          newsletter.sectionThreeTemplate.length > 0 &&
          newsletter.sectionThreeTemplate.map((section, index) => {
            const partOne = section.partOne;
            const partTwo = section.partTwo;

            const hasPartOneData =
              partOne?.titleAndDescription?.title ||
              partOne?.titleAndDescription?.descriptions?.value ||
              partOne?.image?.mediaImage5?.url;

            const hasPartTwoData =
              partTwo?.titleAndDescription?.title ||
              partTwo?.titleAndDescription?.descriptions?.value ||
              partTwo?.image?.mediaImage5?.url;

            if (!hasPartOneData && !hasPartTwoData) return null;

            return (
              <div
                key={section.id}
                className="grid grid-cols-1 md:grid-cols-6 gap-6 items-start my-10"
              >
                {/* Part One - 40% (2/5 columns) */}
                {hasPartOneData && (
                  <div className="md:col-span-3 space-y-3 bg-warm-orange p-6 text-black rounded-2xl shadow-md">
                    {Array.isArray(partOne?.image) && partOne.image.length > 0 && (
                      <div className="mb-2 w-full h-[270px] sm:h-[450px] md:h-[430px] lg:h-[430px] overflow-hidden rounded-xl shadow-sm">
                        <ImageCarousel images={partOne.image} />
                      </div>
                    )}

                    {partOne?.titleAndDescription?.title && (
                      <h2 className="text-xl sm:text-2xl font-semibold text-indian-red font-heading">
                        {partOne.titleAndDescription.title}
                      </h2>
                    )}
                    {partOne?.titleAndDescription?.descriptions?.value && (
                      <div className="relative text-sm text-black font-body text-justify">
                        <div
                          className={`transition-all duration-300 h-[200px] pr-2 ${expandedItems[`sectionThree-partOne-${section.id}`] ? "overflow-y-auto" : "overflow-hidden md:max-h-[200px]"}`}
                        >
                          <div
                            ref={(el) => (descriptionRefs.current[`sectionThree-partOne-${section.id}`] = el)}
                            dangerouslySetInnerHTML={{
                              __html: partOne.titleAndDescription.descriptions.value,
                            }}
                            className="pr-2 font-body"
                          />
                        </div>

                        {!expandedItems[`sectionThree-partOne-${section.id}`] && showReadMoreItems[`sectionThree-partOne-${section.id}`] && (
                          <div className="text-center mt-2 ">
                            <button
                              onClick={() => setExpandedItems((prev) => ({ ...prev, [`sectionThree-partOne-${section.id}`]: true }))}
                              className="text-indian-red font-body font-medium hover:underline  transition"
                            >
                              Read More
                            </button>
                          </div>
                        )}

                        {expandedItems[`sectionThree-partOne-${section.id}`] && (
                          <div className="text-center mt-2 ">
                            <button
                              onClick={() => {
                                const el = descriptionRefs.current[`sectionThree-partOne-${section.id}`];
                                if (el) el.parentElement.scrollTop = 0;
                                setExpandedItems((prev) => ({ ...prev, [`sectionThree-partOne-${section.id}`]: false }));
                              }}
                              className="text-indian-red font-body font-medium hover:underline transition"
                            >
                              Read Less
                            </button>
                          </div>
                        )}
                      </div>
                    )}


                  </div>
                )}

                {/* Part Two - 60% (3/5 columns) */}
                {hasPartTwoData && (
                  <div className="md:col-span-3  space-y-3 bg-white p-6 text-white rounded-2xl shadow-md">
                    {Array.isArray(partTwo?.image) && partTwo.image.length > 0 && (
                      <div className="mb-2 w-full h-[270px] sm:h-[450px] md:h-[430px] lg:h-[430px] overflow-hidden rounded-xl shadow-sm">
                        <ImageCarousel images={partTwo.image} />
                      </div>
                    )}

                    {partTwo?.titleAndDescription?.title && (
                      <h2 className="text-xl sm:text-2xl font-heading font-semibold text-indian-red">
                        {partTwo.titleAndDescription.title}
                      </h2>
                    )}
                    {partTwo?.titleAndDescription?.descriptions?.value && (
                      <div className="relative text-sm text-gray-700 text-justify">
                        <div
                          className={`transition-all duration-300 h-[200px] pr-2 ${expandedItems[`sectionThree-partTwo-${section.id}`] ? "overflow-y-auto" : "overflow-hidden md:max-h-[200px]"}`}
                        >
                          <div
                            ref={(el) => (descriptionRefs.current[`sectionThree-partTwo-${section.id}`] = el)}
                            dangerouslySetInnerHTML={{
                              __html: partTwo.titleAndDescription.descriptions.value,
                            }}
                            className="pr-2 font-body"
                          />
                        </div>

                        {!expandedItems[`sectionThree-partTwo-${section.id}`] && showReadMoreItems[`sectionThree-partTwo-${section.id}`] && (
                          <div className="text-center mt-2">
                            <button
                              onClick={() => setExpandedItems((prev) => ({ ...prev, [`sectionThree-partTwo-${section.id}`]: true }))}
                              className="text-indian-red font-body font-medium underline hover:text-dark-umber transition"
                            >
                              Read More
                            </button>
                          </div>
                        )}

                        {expandedItems[`sectionThree-partTwo-${section.id}`] && (
                          <div className="text-center mt-2">
                            <button
                              onClick={() => {
                                const el = descriptionRefs.current[`sectionThree-partTwo-${section.id}`];
                                if (el) el.parentElement.scrollTop = 0;
                                setExpandedItems((prev) => ({ ...prev, [`sectionThree-partTwo-${section.id}`]: false }));
                              }}
                              className="text-indian-red font-body font-medium underline hover:text-dark-umber transition"
                            >
                              Read Less
                            </button>
                          </div>
                        )}
                      </div>
                    )}


                  </div>
                )}
              </div>
            );
          })}

        {/* ===== Upcoming Plan Section ===== */}

        {newsletter?.upcomingPlan &&
          Array.isArray(newsletter?.upcomingPlanPoints) &&
          newsletter.upcomingPlanPoints.length > 0 && (
            <div className="my-10 text-indian-red bg-warm-orange p-6 rounded-2xl shadow-md">
              {/* Title */}
              <h2 className="text-2xl font-heading font-semibold mb-4">{newsletter.upcomingPlan}</h2>

              {/* Points (show only 5 initially) */}
              <ol className="list-decimal list-outside pl-5">
                {newsletter.upcomingPlanPoints
                  .slice(0, showMoreUpcoming ? newsletter.upcomingPlanPoints.length : 5)
                  .map((point, index) => (
                    <li key={index} className="text-sm font-body text-black mb-2">
                      {point}
                    </li>
                  ))}
              </ol>


              {/* Read More / Read Less */}
              {newsletter.upcomingPlanPoints.length > 5 && (
                <div className="text-center mt-3">
                  <button
                    className="text-warm-orange font-medium hover:underline font-body"
                    onClick={() => setShowMoreUpcoming(!showMoreUpcoming)}
                  >
                    {showMoreUpcoming ? "Read Less" : "Read More"}
                  </button>
                </div>
              )}
            </div>
          )}
        {/* ===== Team Corner Section ===== */}
        {teamCorner && (() => {
          const hasImages =
            Array.isArray(teamCorner.image) &&
            teamCorner.image.some(img => img?.mediaImage5?.[0]?.url);

          if (
            !(teamCorner?.titleAndDescription?.title ||
              teamCorner?.titleAndDescription?.descriptions?.value ||
              hasImages)
          ) {
            return null;
          }
          // console.log("Team Corner Images:", teamCornerImages);

          const teamCornerImages = Array.isArray(teamCorner.image)
            ? teamCorner.image
              .map(img => {
                const media = img?.mediaImage5?.[0];
                return media?.url
                  ? {
                    url: media.url,
                    alt: media.alt || img.name || "Team Corner Image",
                  }
                  : null;
              })
              .filter(Boolean)
            : [];
          // console.log("Team Corner Images:", teamCornerImages);
          return (
            <div>             
              {newsletter.teamCornerMainTitle && (
                <h3 className="text-2xl font-bold text-indian-red text-center font-heading">
                  {newsletter.teamCornerMainTitle}
                </h3>
              )}
            <div className="my-6 bg-white p-4 rounded-2xl shadow-[0_0_25px_rgba(0,0,0,0.25)]">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">

                {/* LEFT SIDE */}
                <div>
                  {teamCorner.titleAndDescription?.title && (
                    <h4 className="text-2xl font-semibold font-heading text-indian-red mb-4">
                      {teamCorner.titleAndDescription.title}
                    </h4>
                  )}

                  {teamCorner.titleAndDescription?.descriptions?.value && (
                    <div className="relative text-gray-700 text-sm text-justify font-body">
                      <div
                        className={`transition-all duration-300 h-[210px] pr-2 ${expandedItems.teamCorner
                          ? "overflow-y-auto"
                          : "overflow-hidden"
                          }`}
                      >
                        <div
                          ref={el => (descriptionRefs.current.teamCorner = el)}
                          dangerouslySetInnerHTML={{
                            __html:
                              teamCorner.titleAndDescription.descriptions.value,
                          }}
                        />
                      </div>

                      <div className="text-center mt-2">
                        <button
                          onClick={() =>
                            setExpandedItems(prev => ({
                              ...prev,
                              teamCorner: !prev.teamCorner,
                            }))
                          }
                          className="text-indian-red font-body font-medium underline"
                        >
                          {expandedItems.teamCorner ? "Read Less" : "Read More"}
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                {/* RIGHT SIDE — IMAGE / CAROUSEL */}
                <div>
                  {Array.isArray(teamCorner.image) && teamCorner.image.length === 1 && (
                    <img
                      src={teamCorner.image[0]?.mediaImage5?.[0]?.url}
                      alt={
                        teamCorner.image[0]?.mediaImage5?.[0]?.alt ||
                        teamCorner.image[0]?.name ||
                        "Team Corner Image"
                      }
                      className="rounded-xl shadow w-full h-[320px] sm:h-[450px] md:h-[430px] lg:h-[320px] object-cover"
                    />
                  )}

                  {Array.isArray(teamCorner.image) && teamCorner.image.length > 1 && (
                    <div className="h-[320px] sm:h-[450px] md:h-[430px] lg:h-[320px] overflow-hidden rounded-xl shadow">
                      <ImageCarousel images={teamCorner.image} />
                    </div>
                  )}

                </div>
              </div>
            </div>
            </div>
          );
        })()}





        {/* Newsletter Description */}
        <div className="text-gray-700 font-body eading-relaxed text-justify">
          <div
            dangerouslySetInnerHTML={{ __html: newsletter?.newsletterDescription?.value }}
          />
        </div>

        {/* Newsletter PDF Link */}
        {newsletter.oldNewsletterPdf && (
          <div className="mt-10">
            <a
              href={newsletter.oldNewsletterPdf.mediaFile.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              Download PDF
            </a>
          </div>
        )}
      </div>
    </section>
  );
};

export default NewsletterDetail;
